define('lq/visibility/itemVisibility',[
    './defaultVisibility'
], function (DefaultVisibility) {
    'use strict';

    var ItemVisibility = function (dataRow, parent) {
        this.dataRow = dataRow;
        this.parent = parent;
        this.default = new DefaultVisibility();
    };

    ItemVisibility.prototype.apply = function (drop) {
        if (this.shouldGetVisibilityFromParent(drop)) {
            // We still hide the drop based on the initial visibility,
            // so that it doesn't show up before the first datasource update
            // comes in. This is needed for example for items in a calendar,
            // which should be hidden (if the initial visibility is false)
            // before the calendar's datasource is applied,
            // but would otherwise show up briefly before the datasource is applied.
            if (drop.data.initialVisibility === false)
                drop.initialHide();
            drop.addListener('DatasourceApplied', this.updateVisibilityFromDataRow.bind(this, drop))
        } else {
            this.default.apply(drop);
        }
    };

    ItemVisibility.prototype.updateVisibilityFromDataRow = function (drop) {
        var isVisibleByQuery = this.dataRow[drop.data.dataSourceOutputForVisibility];
        var isVisible = Boolean(drop.data?.invertVisibility) !== (isVisibleByQuery === true);
        if (isVisible)
            drop.showWithoutAnimation();
        else
            drop.hideWithoutAnimation();
    };

    ItemVisibility.prototype.shouldGetVisibilityFromParent = function (drop) {
        if (drop.data.initialVisibilityOption !== 'From Query')
            return false;
        return drop.data.dataSourceForVisibility === this.parent.data.dataSource || this.parent.data.useParentGroupData;
    };

    ItemVisibility.prototype.cleanUp = function () {
        this.default.cleanUp();
    };

    return ItemVisibility;
});
